import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from '@topconagriculture/react-components';
import { format, subDays, startOfDay } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import { useDashboardConfig } from '../../../hooks/useDashboardContext';
import { dateWithTimeFormat } from '../../../config/constants';
import { useTaskCountByDate, useTaskQuery } from '../../../api/fields/useTaskQuery';
const useStyles = makeStyles((theme) => ({
    lastTaskOverviewContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        padding: '8px 8px 0 8px',
        margin: '0 10px 0 10px',
    },
    bigCircleContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '1 0 50%',
    },
    bigCircle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '90px',
        height: '90px',
        backgroundColor: '#46bc01',
        color: '#fff',
        borderRadius: '50%',
        fontSize: 42,
        lineHeight: '40px',
        marginRight: 10,
        marginLeft: 'auto',
    },
    bigCircleLabel: {
        fontSize: theme.font.size.mediumSmall,
        lineHeight: '12px',
        textAlign: 'center',
        maxWidth: 60,
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        hyphens: 'auto',
        textOverflow: 'ellipsis',
    },
    smallCircleContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: '1 0 50%',
        '@media (max-width: 1274px)': {
            flex: '1 0 60%',
        },
    },
    smallCircleRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    smallCircle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '40px',
        height: '40px',
        border: '2px solid #46bc01',
        color: '#333333',
        borderRadius: '50%',
        fontSize: theme.font.size.big,
        lineHeight: '40px',
        margin: '5px 10px',
    },
    smallCircleLabel: {
        fontSize: theme.font.size.medium,
        maxWidth: 75,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    lastTaskContainerLabel: {
        margin: '0 10px',
        fontSize: theme.font.size.small,
        color: '#9b9b9b',
    },
    lastTaskDetailContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 8,
        margin: '3px 10px 10px 10px',
        minHeight: 91,
        maxHeight: 91,
        borderRadius: 5,
        backgroundColor: '#eceff1',
        '& > span': {
            width: '100%',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
    },
    lastTaskDescription: {
        fontSize: theme.font.size.mediumSmall,
        color: '#9b9b9b',
        '& em': {
            fontStyle: 'normal',
            color: '#333333',
        },
    },
    taskUrl: {
        textDecoration: 'underline',
    },
}));
const TaskWidget = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { TASKS_VIEW_MORE_LINK } = useDashboardConfig();
    const today = new Date();
    const thisWeek = subDays(startOfDay(today), 7);
    const { data: lastTask } = useTaskQuery();
    const { data } = useTaskCountByDate({ fromDate: thisWeek.toISOString() });
    const isLoadingMentorLastTask = false;
    const isLoadingMentorTaskCount = false;
    return (React.createElement(Loading, { isLoading: isLoadingMentorLastTask || isLoadingMentorTaskCount },
        React.createElement("div", { className: classes.lastTaskOverviewContainer },
            React.createElement("div", { className: classes.bigCircleContainer },
                React.createElement("div", { className: classes.bigCircle }, data === null || data === void 0 ? void 0 :
                    data.weekCount,
                    React.createElement("span", { className: classes.bigCircleLabel }, t('widget:tasks:this_week')))),
            React.createElement("div", { className: classes.smallCircleContainer },
                React.createElement("div", { className: classes.smallCircleRow },
                    React.createElement("div", { className: classes.smallCircle }, data === null || data === void 0 ? void 0 : data.todayCount),
                    React.createElement("span", { className: classes.smallCircleLabel }, t('widget:tasks:today'))),
                React.createElement("div", { className: classes.smallCircleRow },
                    React.createElement("div", { className: classes.smallCircle }, data === null || data === void 0 ? void 0 : data.yesterdayCount),
                    React.createElement("span", { className: classes.smallCircleLabel }, t('widget:tasks:yesterday'))))),
        (lastTask === null || lastTask === void 0 ? void 0 : lastTask.endDate) ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: classes.lastTaskContainerLabel }, t('widget:tasks:last_logged')),
            React.createElement("div", { className: classes.lastTaskDetailContainer },
                React.createElement("span", { className: classes.lastTaskDescription }, format(new Date((lastTask || {}).endDate), dateWithTimeFormat)),
                React.createElement("span", null,
                    React.createElement("a", { href: `${TASKS_VIEW_MORE_LINK}/${lastTask.fieldId}`, target: "_blank", rel: "noopener noreferrer", className: classes.taskUrl }, lastTask.name)),
                React.createElement("span", { className: classes.lastTaskDescription },
                    t('common:with'),
                    React.createElement("em", null,
                        " ",
                        (lastTask.product || {}).name)),
                React.createElement("span", { className: classes.lastTaskDescription },
                    t('widget:tasks:on_field'),
                    React.createElement("em", null,
                        " ",
                        ((lastTask.field || [])[0] || {}).name))))) : (React.createElement("div", { className: classes.lastTaskDetailContainer }, t('widget:tasks:no_tasks')))));
};
export default TaskWidget;
//# sourceMappingURL=TaskWidget.js.map